import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { UL } from '@blueprintjs/core';
import './KwicTable.css';

class Meta extends React.PureComponent {

  state = {
     
  }

  render() {
    const metadata=this.props.metadata;

    const metaDataEls = Object.keys(metadata).sort().map(key => (
        (key==='externalLink') ? 
          <li key={key}>{key}: <a target="blank" href={metadata[key]}>{metadata[key]}</a></li>:
          <li key={key} dangerouslySetInnerHTML={{ __html:'<b>'+key+"</b>: "+(metadata[key].match(/\\n/)?"<br/>- ":"")+metadata[key].replace(/\\n/g,"<br/>- ")}}></li>
    ));
    metaDataEls.unshift(
      <li key='sentId'><b>sentId</b>: {this.props.sentId}</li> 
    );

        return (
          <div className='dialogContainer'>
            <UL>
                {metaDataEls}
            </UL>
          </div>  
        );

  }
}

Meta.propTypes = {
      metadata: PropTypes.object,
      sentId: PropTypes.string,

};

export default withTranslation()(Meta);
